import {HeroBlock} from "@/pages/common/Home/components/HeroBlock";
import {HeroTitle} from "@/pages/common/Home/components/HeroTitle";

import consistent_hover from "@images/home/cases/consistent-hover.svg";
import consistent from "@images/home/cases/consistent.svg";
import feedback_hover from "@images/home/cases/feedback-hover.svg";
import feedback from "@images/home/cases/feedback.svg";
import handling_hover from "@images/home/cases/handling-hover.svg";
import handling from "@images/home/cases/handling.svg";
import intelligens_hover from "@images/home/cases/intelligens-hover.svg";
import intelligens from "@images/home/cases/intelligens.svg";
import launch_hover from "@images/home/cases/launch-hover.svg";
import launch from "@images/home/cases/launch.svg";
import omni_hover from "@images/home/cases/omni-hover.svg";
import omni from "@images/home/cases/omni.svg";
import regular_hover from "@images/home/cases/regular-hover.svg";
import regular from "@images/home/cases/regular.svg";
import shift_hover from "@images/home/cases/shift-hover.svg";
import shift from "@images/home/cases/shift.svg";
import wining_hover from "@images/home/cases/wining-hover.svg";
import wining from "@images/home/cases/wining.svg";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const Intro = () => {
  const {t} = useTranslation();

  const cardList = [
    {
      id: 0,
      icon: launch,
      iconHover: launch_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_1"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_1"),
          }}
        />
      ),
    },
    {
      id: 1,
      icon: regular,
      iconHover: regular_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_2"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_2"),
          }}
        />
      ),
    },
    {
      id: 2,
      icon: omni,
      iconHover: omni_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_3"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_3"),
          }}
        />
      ),
    },
    {
      id: 3,
      icon: shift,
      iconHover: shift_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_4"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_4"),
          }}
        />
      ),
    },
    {
      id: 4,
      icon: handling,
      iconHover: handling_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_5"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_5"),
          }}
        />
      ),
    },
    {
      id: 5,
      icon: feedback,
      iconHover: feedback_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_6"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_6"),
          }}
        />
      ),
    },
    {
      id: 6,
      icon: wining,
      iconHover: wining_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_7"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_7"),
          }}
        />
      ),
    },
    {
      id: 7,
      icon: intelligens,
      iconHover: intelligens_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_8"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_8"),
          }}
        />
      ),
    },
    {
      id: 8,
      icon: consistent,
      iconHover: consistent_hover,
      title: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.title_9"),
          }}
        />
      ),
      subtitle: (
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.card.desc_9"),
          }}
        />
      ),
    },
  ];

  return (
    <div className={styles.intro}>
      <HeroTitle>
        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.intro_title"),
          }}
        />

        <span
          dangerouslySetInnerHTML={{
            __html: t("page.cases.intro_desc"),
          }}
        />
      </HeroTitle>

      <div className={"container-home"}>
        <HeroBlock
          cardsTitle={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.commercial.title"),
              }}
            />
          }
          cards={cardList}
          itemHover={"linear-gradient(135deg, #8692CB 0%, #B262C9 100%)"}
          description={
            <span
              dangerouslySetInnerHTML={{
                __html: t("page.cases.commercial.desc"),
              }}
            />
          }
        />
      </div>
    </div>
  );
};
